import React from 'react'
import { useTranslation } from "react-i18next";
import { IconButton } from '@fluentui/react/lib/Button';
import { getTheme, mergeStyleSets, FontWeights, Modal } from '@fluentui/react';
import {  Row, Col } from "react-bootstrap"
import { DefaultButton } from '@fluentui/react/lib/Button';
import CLabel from '../../../../Common/CLabel';
import { isNullUndefined } from '../../../../../common/Helpers';
    
    function AditionalInfoModal(props) {
        const { t } = useTranslation();
        
        const inputParam_RelatedConceptItem = props.relatedConceptItem !== null && props.relatedConceptItem !== undefined ? props.relatedConceptItem : null;
        const inputParam_IsModalOpen = props.isModalOpen !== null && props.isModalOpen !== undefined ? props.isModalOpen : null;
        const inputParam_HideModal = props.hideModal !== null && props.hideModal !== undefined ? props.hideModal : null;
        const inputParam_Book = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
        

        const theme = getTheme();
        const contentStyles = mergeStyleSets({
            container: {
                display: 'flex',
                flexFlow: 'column nowrap',
                alignItems: 'stretch',
            },
            header: [
                {
                    flex: '1 1 auto',
                    borderTop: `4px solid ${theme.palette.themePrimary}`,
                    color: theme.palette.neutralPrimary,
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: FontWeights.semibold,
                    padding: '12px 12px 14px 24px',
                },
            ],
            body: {
                flex: '4 4 auto',
                padding: '0 24px 24px 24px',
                overflowY: 'hidden',
                selectors: {
                    p: { margin: '14px 0' },
                    'p:first-child': { marginTop: 0 },
                    'p:last-child': { marginBottom: 0 },
                },
            },
            footer: [
                {
                    flex: '1 1 auto',
                    borderTop: `1px solid ${theme.palette.green}`,
                    color: theme.palette.neutralPrimary,
                    display: 'flex',
                    fontWeight: FontWeights.semibold,
                    padding: '12px 12px 14px 24px',
                },
            ],
        });
        const iconButtonStyles = {
            root: {
                color: theme.palette.neutralPrimary,
                marginLeft: 'auto',
                marginTop: '4px',
                marginRight: '2px',
            },
            rootHovered: {
                color: theme.palette.neutralDark,
            },
        };
        
        //Render de componente.
        return (
            <Modal
                isOpen={ inputParam_IsModalOpen }
                onDismiss={ inputParam_HideModal }
                isBlocking={false}
                containerClassName={contentStyles.container}
                dragOptions={ false }            
                className="custom-modal-document-link"
            >
                <div className={contentStyles.header}>
                    <span>{ t('data-lang-boxname-aditionalinfo') }</span>
                    <IconButton
                        styles={iconButtonStyles}
                        iconProps={{ iconName: 'Cancel' }}
                        onClick={ inputParam_HideModal }
                    />
                </div>
                <div className={ contentStyles.body}>
                    <div style={{ height: "20%", position: "relative" }}>
                        {
                            inputParam_RelatedConceptItem.id !== null && inputParam_RelatedConceptItem.id !== 0 &&
                            <>
                                <Row className="pt-3">
                                    <Col xl={12}>
                                        <CLabel labelText={t('data-lang-lbl-name')} labelValue={inputParam_RelatedConceptItem.name} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                </Row>
                                <Row className="pt-3">
                                    <Col xl={6}>
                                        <CLabel labelText={t('data-lang-lbl-legalentitybuyername')} labelValue={inputParam_RelatedConceptItem.legalEntityBuyerName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                    <Col xl={6}>
                                        <CLabel labelText={t('data-lang-lbl-legalentitysuppliername')} labelValue={inputParam_RelatedConceptItem.legalEntitySupplierName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                 </Row>
                                <Row className="pt-3">
                                    <Col xl={6}>
                                        <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={inputParam_RelatedConceptItem.businessUnitName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                    <Col xl={6}>
                                        <CLabel labelText={t('data-lang-lbl-segmentname')} labelValue={inputParam_RelatedConceptItem.segmentName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                </Row>
                                <Row className="pt-3">
                                    <Col xl={6}>
                                        <CLabel labelText={t('data-lang-lbl-currencyname')} labelValue={inputParam_RelatedConceptItem.currencyName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                    <Col xl={6}>
                                        <CLabel labelText={t('data-lang-lbl-adminuser')} labelValue={inputParam_RelatedConceptItem.adminUsername} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                    </Col>
                                </Row>
                                {
                                    false && !isNullUndefined(inputParam_Book) && !isNullUndefined(inputParam_Book.creationDate) &&
                                    <Row>
                                        <Col>
                                            <CLabel labelText={t("data-lang-lbl-bookcreaciondate")} labelValue={inputParam_Book.creationDate} />
                                        </Col>
                                    </Row>
                                }
                            </>
                        }
                    </div>
                </div>
                <div className={contentStyles.footer}>
                    <Col>
                        <div className="text-end">
                            <DefaultButton onClick={ inputParam_HideModal }>{ t('data-lang-btn-close') }</DefaultButton>
                        </div>
                    </Col>
                </div>
            </Modal>
            );
    }
        
    export default AditionalInfoModal;